<p-select
    class="w-14rem"
    itemSize="32"
    #ddUser
    [options]="Users"
    optionLabel="EmployeeName"
    [filter]="this.filter"
    appendTo="body"
    dataKey="EmployeeListID"
    autoDisplayFirst="false"
    name="ddUser"
>
</p-select>
